// extracted by mini-css-extract-plugin
export default {"cityLinkList":"c-a_fK"};